import { z } from 'zod/v4';

export enum SrmApprovalStatus {
    Pending = 'pending',
    Approved = 'approved',
    PartiallyApproved = 'partially_approved',
    Rejected = 'rejected',
    Unknown = 'unknown',
}

export enum SrmDocumentType {
    Generic = 'GENERIC',
    Certificate = 'CERTIFICATE',
    Bucket = 'BUCKET',
    Unknown = 'UNKNOWN',
}

export enum SrmDocumentStatus {
    Open = 'open',
    Pending = 'pending',
    Approved = 'approved',
    Expired = 'expired',
    ChangeRequested = 'change_requested',
    NotRelevant = 'not_relevant',
    Unknown = 'unknown',
}

export enum SrmGrade {
    A = 'A',
    B = 'B',
    C = 'C',
    Unknown = 'Unknown',
}

export type SrmOnTimeDeliveryDTO = z.infer<typeof SrmOnTimeDeliveryRuntype>;
export const SrmOnTimeDeliveryRuntype = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('received'),
        /** Percentage of receipts that landed inside the tenant's on-time window. */
        percentage: z.number(),
    }),
    /** Nothing was received in the period. A quiet period is not a bad one, so there is no 0%. */
    z.object({ status: z.literal('not_received') }),
    z.object({ status: z.literal('unknown') }),
]);

export type SrmLastEvaluationDTO = z.infer<typeof SrmLastEvaluationRuntype>;
export const SrmLastEvaluationRuntype = z.discriminatedUnion('status', [
    z.object({
        status: z.literal('scored'),
        total_score: z.number(),
        grade: z.enum(SrmGrade),
    }),
    z.object({ status: z.literal('not_scored') }),
    z.object({ status: z.literal('unknown') }),
]);

export interface SrmSupplierDocumentDTO extends z.infer<typeof SrmSupplierDocumentRuntype> {}
export const SrmSupplierDocumentRuntype = z.object({
    document_entry_id: z.string(),
    name: z.string(),
    type: z.enum(SrmDocumentType),
    status: z.enum(SrmDocumentStatus),
});

export interface SupplierSrmOverviewDTO extends z.infer<typeof SupplierSrmOverviewRuntype> {}
export const SupplierSrmOverviewRuntype = z.object({
    approval_status: z.enum(SrmApprovalStatus).nullable(),
    ontimedelivery: SrmOnTimeDeliveryRuntype,
    /** `null` when the supplier was never evaluated. */
    last_evaluation: SrmLastEvaluationRuntype.nullable(),
    documents: z.array(SrmSupplierDocumentRuntype),
});
